import React from 'react'
import SurveyListHeader from '../../../../../component/common/layout/SurveyListHeader'
import SurveyListSidebar from '../../../../../component/common/layout/SurveyListSidebar';
import Svg from '../../../../../component/common/Svg';
import style from "../../../../style.module.css";

import { useDevice } from "../../../../customHooks";
import Card from '../../../../../core/Card';
import Typography from '../../../../../core/Typography';
import Input from "../../../../../core/Inputs/DefaultInput";
import { Link } from 'react-router-dom';
import bannerImg from "../../../../../assets/images/lead-gen-form.jpg"
import Tooltip from '../../../../../core/Tooltip';
import logo1 from "../../../../../assets/images/logo-upload1.svg";
import logo2 from "../../../../../assets/images/logo-upload2.svg";

export default function DesignLandingPage(props) {
    const { view, color, pos, isOpen } = props;
    let device = useDevice();
    const flexDirection = device === "mobile" ? "column" : "row";
    const alignItems = device === "mobile" ? "flex-start" : "initial";
    return (
        <>
            <div className='d-flex flex-column main-outer-wrapper main-site-wrapper'>
                <SurveyListHeader />
                <div id="viewport" className="d-flex">
                    <SurveyListSidebar />
                    <div id="content" className="flex-grow-1 dashboard-page-outer">
                        {/* <SubHeader /> */}
                        <div className="survey-design-container d-flex">
                            {/**New Sidebar Code */}
                            <div className="design-sidebar">
                                <div className="design-default-sidebar">

                                    <div className="side-tab-wrapper pt-0">
                                        {/* breadcrumbs here */}
                                        <nav aria-label="breadcrumb">
                                            <ol className="breadcrumb">
                                                <li className="breadcrumb-item">
                                                    <Link to="/admin/survey/list">Survey</Link>
                                                </li>
                                                <li className="breadcrumb-item">
                                                    <a href="#">Survey Name</a>
                                                </li>
                                                <li className="breadcrumb-item">
                                                    <a href="#">Landing Pages</a>
                                                </li>
                                                <li className="breadcrumb-item">
                                                    <a href="#">Landing Page 1</a>
                                                </li>
                                                <li className="breadcrumb-item active" aria-current="page">
                                                    <strong>Customize</strong>
                                                </li>
                                            </ol>
                                        </nav>
                                        {/* breadcrumbs ends here */}
                                        <div className="gx-3 row">

                                            <div className="col-md-12">
                                                <div className="logo-edit">

                                                    <div className="text-small-gray">Background</div>
                                                    {/* Logo1 Edit start */}
                                                    <div className="box-edit">
                                                        <div class="panel-edit d-flex justify-content-between align-items-center">
                                                            <div className="title-small-text">Background</div>
                                                            <div className="d-flex align-items-center justify-content-end">
                                                                <div className="action-wrapper d-flex tooltipsBtns">

                                                                    <Tooltip
                                                                        view={view}
                                                                        color='primary'
                                                                        content="Change picture"
                                                                        position='top'
                                                                        // isOpen={isOpen ? isOpen : null}
                                                                        className='black-tooltip'
                                                                    >
                                                                        <button data-bs-toggle="modal" data-bs-target="#addFile" className='btn   action-btn'><Svg name="gallery-black" /></button>
                                                                    </Tooltip>
                                                                    <Tooltip
                                                                        view={view}
                                                                        color='primary'
                                                                        content="Delete picture"
                                                                        position='top'
                                                                        // isOpen={isOpen ? isOpen : null}
                                                                        className='black-tooltip'
                                                                    >
                                                                        <button type="button" className="btn   action-btn" data-bs-toggle="modal" data-bs-target="#editPins" srno="1" value="1"><Svg name="delete" /></button>
                                                                    </Tooltip>

                                                                </div>

                                                            </div>
                                                        </div>
                                                        <div className="logoPosition  d-flex justify-content-between align-items-center">
                                                            <div className="leftLogo banner-upload">
                                                                {/*If image is removed show this */}
                                                                {/* <img src={logo1} alt="Logo" className='default'/> */}
                                                                {/*Else this */}
                                                                <img src={bannerImg} className='uploaded' />
                                                            </div>

                                                            <div className='survey-format-dropdown d-flex justify-content-between align-items-center'>
                                                                <div class="info-text surveyDesign">Position</div>
                                                                <div className="btn-group">
                                                                    <div class="selectBox">

                                                                        <div className="select-type d-flex align-items-center">
                                                                            <select className="form-control fontFamily" >
                                                                                <option>Top center</option>
                                                                                <option>Top left</option>
                                                                                <option>Top right</option>
                                                                                <option>Center left</option>
                                                                                <option>Center center</option>
                                                                                <option>center right</option>
                                                                                <option>bottom left</option>
                                                                                <option>bottom center</option>
                                                                                <option>bottom right</option>
                                                                            </select>
                                                                        </div>


                                                                    </div>
                                                                </div>

                                                            </div>

                                                        </div>


                                                    </div>
                                                    {/* Logo Edit end */}
                                                    {/* IF image is removed, show this */}
                                                    {/* <div className="box-edit">
                                                        <div class="panel-edit d-flex justify-content-between align-items-center">
                                                            <div className="title-small-text">Background image</div>
                                                            <div class="image-upload">

                                                                <div className="border-divider"></div>
                                                                <input type="file" id="upload" hidden />
                                                                <button data-bs-toggle="modal" data-bs-target="#addBackground" className='fileUpload btn btn-bordered'>Add</button>
                                                            </div>
                                                        </div>
                                                    </div> */}

                                                    {/* Ends Here */}

                                                    <div className="text-small-gray">TEXT</div>
                                                    <div className="box-edit">
                                                        <div class="panel-edit">
                                                            <div className="title-small-text mb-2">Title</div>
                                                            < Input
                                                                type='text'
                                                                view='outlined'
                                                                dense={false}
                                                                color='default'
                                                                label=''
                                                                placeholder='Title'
                                                                clearButton={true}
                                                                success={false}
                                                                error={false}
                                                                fill={true}
                                                                errorHelperText={null}
                                                                className={"formsinput"}
                                                                value='Lorem ipsum dolor sit amet, consectetur adipiscing elit'
                                                            />
                                                        </div>

                                                        <div className="divider-edit" />

                                                        <div class="panel-edit">
                                                            <div className="title-small-text mb-2">Description</div>
                                                            <textarea className="form-control" rows={3} defaultValue={"Lorem ipsum dolor sit amet consectetur. Et sem nibh nulla bibendum malesuada mi. Netus quis arcu scelerisque suspendisse pellentesque netus. Donec quis proin metus massa. Eleifend in nunc proin."} />
                                                            <div className="form-help mt-2 text-end">
                                                                <p>To edit form <Link target='_blank' to="/admin/survey/form-builder">Click here</Link> </p>
                                                            </div>
                                                        </div>

                                                    </div>

                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <button className="btn btn-bordered  w-100 ">Cancel</button>
                                            </div>
                                            <div className="col-md-6">
                                                <button type="button" className="btn btn-primary add-btn  w-100" data-bs-toggle="modal" data-bs-target="#editPins" srno="1" value="1">Save & Apply</button>

                                            </div>
                                        </div>
                                    </div>


                                </div>

                            </div>


                            {/**Right Bar Code */}
                            <div className='flex-grow-1'>


                                <>
                                    <div className="lead-gen-wrapper">
                                        <div className="row gx-0">
                                            <div className="col-lg-6 d-none d-lg-flex">
                                                <div className="img-wrapper">
                                                    <img src={bannerImg} alt="bannerImg" />
                                                </div>
                                            </div>
                                            <div className="col-lg-6">
                                                <div className="text-wrapper">
                                                    <div className="text-inner">
                                                        <div className="heading-wrapper">
                                                            <h1>Lorem ipsum dolor sit amet, consectetur adipiscing elit</h1>
                                                        </div>
                                                        <div className="form-wrapper">
                                                            <form>

                                                                <div className="form-floating mb-3">
                                                                    <input type="text" className="form-control" id="floatingInput" placeholder='Full Name*' />
                                                                    <label htmlFor="floatingInput">Full Name*</label>
                                                                </div>
                                                                <div className="form-floating mb-3">
                                                                    <input type="email" className="form-control" id="floatingInput" placeholder='Company email*' />
                                                                    <label htmlFor="floatingInput">Company email*</label>
                                                                </div>
                                                                <div className="form-floating mb-3">
                                                                    <input type="text" className="form-control" id="floatingInput" placeholder='Designation' />
                                                                    <label htmlFor="floatingInput">Designation</label>
                                                                </div>

                                                                <div className="form-floating mb-3">
                                                                    <input type="text" className="form-control" id="floatingInput" placeholder='Industry' />
                                                                    <label htmlFor="floatingInput">Industry</label>
                                                                </div>

                                                                <div className="form-floating mb-3">
                                                                    <input type="text" className="form-control" id="floatingInput" placeholder='Region*' />
                                                                    <label htmlFor="floatingInput">Region*</label>
                                                                </div>

                                                                <div className="font-desclaimer">
                                                                    <p>Lorem ipsum dolor sit amet consectetur. Et sem nibh nulla bibendum malesuada mi. Netus quis arcu scelerisque suspendisse pellentesque netus. Donec quis proin metus massa. Eleifend in nunc proin.</p>
                                                                </div>
                                                                <div className="btn-wrapper">
                                                                    <button className='btn btn-primary btn-icon' type='submit'>
                                                                        Submit
                                                                    </button>
                                                                </div>
                                                            </form>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>

                            </div>

                        </div>
                        <div className="customvar-modal modal fade edit-pop-modal save-design-popup" id="editPins" tabIndex={-1} aria-labelledby="editModalLabel" aria-hidden="true">
                            <div className="modal-dialog modal-dialog-centered">
                                <div className="modal-content">
                                    <div className="modal-body">
                                        <div className={"formcontainer" + " " + style.container}>
                                            <div className={"formvawrapper" + " " + style.wrapper}>
                                                <Card view="raised" className={"formstyle p-4" + " " + style.card} >
                                                    <Typography
                                                        type={device === "mobile" ? "h6" : "h5"}
                                                        colorStep={100}
                                                        tagName="div"
                                                        className={"formhead "}
                                                    >
                                                        Save your changes to this theme?
                                                    </Typography>

                                                    <div className="input_with_info ">
                                                        <Input
                                                            type="text"
                                                            view="outlined"
                                                            color="default"
                                                            label=""
                                                            // placeholder="Label"
                                                            placeholder={'Copy of rosebud'}
                                                            // value={}
                                                            fill
                                                            className={"formsinput themeName" + " " + style.card__exp}

                                                        />
                                                    </div>
                                                    <div className="button-wrap d-flex justify-content-end">
                                                        <button type="button" className="btn btn-bordered" data-bs-dismiss="modal">Discard</button>
                                                        <button type="button" className="btn btn-primary ms-3">Save changes</button>
                                                    </div>
                                                </Card>
                                            </div >

                                        </div >
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="customvar-modal modal fade upload-file-modal" id="addFile" tabIndex={-1} aria-labelledby="editModalLabel" aria-hidden="true">
                            <div className="modal-dialog modal-dialog-centered">
                                <div className="modal-content">
                                    <div className="modal-body">
                                        <div className={"formcontainer" + " " + style.container}>
                                            <div className={"formvawrapper" + " " + style.wrapper}>
                                                <Card view="raised" className={"formstyle p-4" + " " + style.card} >
                                                    <div className="card-heading d-flex justify-content-between">
                                                        <h5>Upload logo </h5>
                                                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                                                    </div>
                                                    <div className="file-upload-box">
                                                        <div className="icon-wrap">
                                                            <Svg name="file-upload" />
                                                        </div>
                                                        <div className="button-wrap">
                                                            <button type="button" className="btn btn-primary">Upload</button>
                                                        </div>
                                                        <p>Supported files - <i>JPG, PNG, JPEG, SVG</i></p>
                                                    </div>
                                                </Card>
                                            </div >

                                        </div >
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div className="customvar-modal modal fade upload-file-modal" id="addBackground" tabIndex={-1} aria-labelledby="editModalLabel" aria-hidden="true">
                            <div className="modal-dialog modal-dialog-centered">
                                <div className="modal-content">
                                    <div className="modal-body">
                                        <div className={"formcontainer" + " " + style.container}>
                                            <div className={"formvawrapper" + " " + style.wrapper}>
                                                <Card view="raised" className={"formstyle p-4" + " " + style.card} >
                                                    <div className="card-heading">
                                                        <h5>Upload Background image</h5>
                                                        <p>Note:- Image width should not be less than 1200px</p>
                                                    </div>
                                                    <div className="file-upload-box">
                                                        <div className="icon-wrap">
                                                            <Svg name="file-upload" />
                                                        </div>
                                                        <div className="button-wrap">
                                                            <button type="button" className="btn btn-primary">Upload</button>
                                                        </div>
                                                        <p>Supported files - <i>JPG, PNG, JPEG, SVG</i></p>
                                                    </div>
                                                </Card>
                                            </div >

                                        </div >
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

        </>
    )
}
